module.exports = __webpack_public_path__ + "img/center-sample.6122b104.png";